import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
export const useEstateSettingNewRoundSchema = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Forms.errors' })

  const schema = useMemo(
    () =>
      yup
        .object()
        .shape({
          endDate: yup.date().required(t('required')),
          endTime: yup.string().required(t('required')),
          isPublicRound: yup.boolean().required(t('required')),
          buyerMemberIds: yup
            .array(yup.string().min(1, t('required')).required(t('required')))
            .when('isPublicRound', {
              is: false,
              then: (schema) =>
                schema.min(1, t('required')).required(t('required')),
              otherwise: (schema) => schema.notRequired(),
            })
            .required(t('required')),
          blindRound: yup.boolean().required(t('required')),
          enforceOfferGap: yup.boolean().required(t('required')),
          minOfferGap: yup
            .number()
            .min(0, t('min_number'))
            .when('enforceOfferGap', {
              is: true,
              then: (schema) => schema.required(t('required')),
              otherwise: (schema) => schema.notRequired(),
            }),
        })
        .test(
          'incompatible-options',
          t('incompatibleBlindAndGap'),
          function (values) {
            if (values.blindRound && values.enforceOfferGap) {
              return this.createError({
                path: 'enforceOfferGap',
                message: t('incompatibleBlindAndGap'),
              })
            }
            return true
          }
        ),
    [t]
  )

  return { schema }
}

export type EstateSettingNewRoundFormValues = yup.InferType<
  ReturnType<typeof useEstateSettingNewRoundSchema>['schema']
>
